
import { Company } from "@authentic-labs/vue-component-library";
import { Component, Vue, Prop } from "vue-property-decorator";
import ContentSection from "../../models/ContentSection";

@Component({
  components: {
  },
})
export default class AddCompanySection extends Vue {
  @Prop()
  companyContentType!: string;

  get company(): Company {
    return this.$store.getters.company;
  }

  get activeContentSections(): ContentSection[] {
    return this.$store.getters.contentSection;
  }
  get customSections(): ContentSection[] {
    return this.$store.getters.customSection;
  }
  get paidSections(): ContentSection[] {
    return this.$store.getters.paidSection;
  }
  get selectableContentSections(): ContentSection[] {
    let selectable = [];
    let sections = [];
    this.companyContentType === "signature"
      ? (sections = this.customSections)
      : (sections = this.paidSections);
    selectable = sections.filter(
      (section) =>
        !this.activeContentSections.some(
          (sectionInUse) =>
            section.id === sectionInUse.id && sectionInUse.pivot?.active
        )
    );
    return selectable.filter((section) => !section.fixed);
  }

  get subscription() {
    return this.$store.getters.subscription
  }

  newSection(section: ContentSection) {
    this.$emit("newSection", section);
  }

  showBusinessContent() {
    this.$root.$emit("show-business-upgrade");
  }

  // async confirmDeleteSection(contentId: number) {
  //   const index = this.contentable.unpublishedContent.findIndex(
  //     (p) => p.id === contentId
  //   );
  //   this.$root.$emit("show-content-confirm", index, contentId);
  // }
}
